import {html, css, TemplateResult, CSSResultGroup} from 'lit'
import {customElement, property} from 'lit/decorators.js'
import {BaseComponent} from '../base-component.js'

@customElement('il-card-title')
export default class CardTitleComponent extends BaseComponent {
  static override styles: CSSResultGroup = [
    BaseComponent.styles,
    css`
      .il-card-title {
        display: flex;
        gap: 8px;
        justify-content: space-between;
        align-items: center;
        position: relative;
        color: var(--il-color-neutrals-350);
        font-size: var(--il-font-size-16);
        font-weight: var(--il-font-weight-xbold);
        line-height: var(--il-font-line-height-150);
        letter-spacing: var(--il-font-letter-spacing-2);
      }

      .il-card-title__extra {
        display: flex;
        padding: 3px 7px; // should be 4px 8px but we are accounting for the border width
        align-items: center;
        border-radius: 4px;
        border: 1px solid var(--il-color-accent-100);
        line-height: var(--il-font-line-height-125);
        background: var(--il-color-accent-50);
      }
    `,
  ]

  @property({attribute: 'extra-title', type: String})
  extraTitle: string = ''

  extraTitleComponent (): TemplateResult {
    if (this.extraTitle) {
      return html` <div
        class="il-card-title__extra"
        data-test-iliad-card-title-extra
      >
        ${this.extraTitle}
      </div>`
    }

    return html``
  }

  override render (): TemplateResult {
    return html`
      <div
        class="${this.baseCSSClass} il-card-title"
        data-test-iliad-card-title
      >
        <div class="il-card-title-content"><slot></slot></div>
        ${this.extraTitleComponent()}
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'il-card-title': CardTitleComponent
  }
}
